function toggleTabs(el) {

	const tabs = [...el.querySelectorAll('.tabbedcontent__tab')]
	var activeTab = el.querySelector('.tabbedcontent__tab.active')

	const content = el.querySelectorAll('.tabbedcontent__content__item')
	var activeContent = el.querySelector('.tabbedcontent__content__item.active')

	let tabFocus = 0; // Enable arrow navigation between tabs in the tab list

	function clickHandler(event) {
        const tab = event.currentTarget
		var tabID = parseInt(tab.getAttribute('data-tab') || '')

		content.forEach(item => {
			var contentID = parseInt(item.getAttribute('data-tab') || '')
			if (contentID === tabID) {
                removeClasses()

                activeTab = tab
                tab.classList.add('active')
				tab.setAttribute('aria-selected', 'true')

				activeContent = item
				item.classList.add('active')
				item.removeAttribute('hidden')

			}
		})
	}
	
	function removeClasses() {
		activeTab && activeTab.classList.remove('active')
		activeTab && activeTab.setAttribute('aria-selected', 'false')
		activeContent && activeContent.classList.remove('active')
		activeContent && activeContent.setAttribute('hidden', true)
	}

	function handleFocus(event) {
		if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
			tabs[tabFocus].setAttribute("tabindex", -1);
			// Right arrow
			if (event.key === "ArrowRight") { 
				tabFocus++;
				// If we're at the end, go to the start
				if (tabFocus >= tabs.length) {
					tabFocus = 0;
				}
			// Move left
			} else if (event.key === "ArrowLeft") {
				tabFocus--;
			  	// If we're at the start, move to the end
				if (tabFocus < 0) {
					tabFocus = tabs.length - 1;
				}
			}

			tabs[tabFocus].setAttribute("tabindex", 0);
			tabs[tabFocus].focus();
		}
	}

	tabs.forEach(function(tab) {
		tab.addEventListener('click', clickHandler)
		tab.addEventListener('keydown', handleFocus)
	})
}


[...document.querySelectorAll('.tabbedcontent')].map(toggleTabs)